// Dummy booking, conversation and review fixtures for the guest account.
// Structure matches the response contracts implied by the AI brief so swapping
// to real /api/v1/guest data later is a one-line change.

import { PROPERTIES } from "@/data/properties";

const p = (id) => PROPERTIES.find((x) => x.id === id);

export const BOOKINGS = [
  {
    id: "SE-8421A",
    property: p("villa-tramonto"),
    status: "confirmed",
    checkIn: "2026-04-12",
    checkOut: "2026-04-19",
    nights: 7,
    guests: 4,
    total: 4610,
    invoiceReady: true,
    unreadMessages: 2,
    canReview: false,
  },
  {
    id: "SE-8399B",
    property: p("black-ridge-cabin"),
    status: "confirmed",
    checkIn: "2026-06-02",
    checkOut: "2026-06-06",
    nights: 4,
    guests: 3,
    total: 1732,
    invoiceReady: false,
    unreadMessages: 0,
    canReview: false,
  },
  {
    id: "SE-7712F",
    property: p("warehouse-08"),
    status: "completed",
    checkIn: "2025-11-14",
    checkOut: "2025-11-18",
    nights: 4,
    guests: 2,
    total: 1289,
    invoiceReady: true,
    unreadMessages: 0,
    canReview: true,
  },
  {
    id: "SE-7431K",
    property: p("palm-bungalow"),
    status: "completed",
    checkIn: "2025-08-04",
    checkOut: "2025-08-10",
    nights: 6,
    guests: 2,
    total: 1470,
    invoiceReady: true,
    unreadMessages: 0,
    canReview: false, // already reviewed
  },
];

export const CONVERSATIONS = [
  {
    bookingId: "SE-8421A",
    property: p("villa-tramonto"),
    host: { name: "Isabella R.", avatar: p("villa-tramonto").host.avatar },
    lastMessage:
      "The keys will be with our caretaker Salvo — I'll share his number 24h before check-in.",
    lastTimestamp: "2 hours ago",
    unread: 2,
    stayDates: "12 – 19 Apr 2026",
    open: true,
    messages: [
      {
        id: 1,
        from: "guest",
        body:
          "Hi Isabella — really excited for the villa! Any recommendation for a quiet restaurant in Positano the night we arrive?",
        at: "2 days ago",
      },
      {
        id: 2,
        from: "host",
        body:
          "Ciao Alex! Try Da Adolfo — they'll pick you up from Positano beach in a wooden boat. It's magic.",
        at: "2 days ago",
      },
      {
        id: 3,
        from: "guest",
        body: "Perfect. And for check-in day — where do we pick up the keys?",
        at: "3 hours ago",
      },
      {
        id: 4,
        from: "host",
        body:
          "The keys will be with our caretaker Salvo — I'll share his number 24h before check-in.",
        at: "2 hours ago",
      },
    ],
  },
  {
    bookingId: "SE-8399B",
    property: p("black-ridge-cabin"),
    host: { name: "Marcus L.", avatar: p("black-ridge-cabin").host.avatar },
    lastMessage:
      "The hot tub will be pre-heated the day you arrive — no need to think about it.",
    lastTimestamp: "3 days ago",
    unread: 0,
    stayDates: "2 – 6 Jun 2026",
    open: true,
    messages: [
      {
        id: 1,
        from: "guest",
        body: "Hi Marcus, does the cabin have space for a small SUV?",
        at: "4 days ago",
      },
      {
        id: 2,
        from: "host",
        body: "Yes — parking for two vehicles right at the door. See you in June.",
        at: "3 days ago",
      },
      {
        id: 3,
        from: "host",
        body:
          "The hot tub will be pre-heated the day you arrive — no need to think about it.",
        at: "3 days ago",
      },
    ],
  },
  {
    bookingId: "SE-7712F",
    property: p("warehouse-08"),
    host: { name: "June K.", avatar: p("warehouse-08").host.avatar },
    lastMessage: "So glad you enjoyed the loft. Come back any time.",
    lastTimestamp: "Nov 2025",
    unread: 0,
    stayDates: "14 – 18 Nov 2025",
    open: false, // messaging closed 24h after checkout
    messages: [
      {
        id: 1,
        from: "host",
        body: "So glad you enjoyed the loft. Come back any time.",
        at: "Nov 19, 2025",
      },
    ],
  },
];

export const TESTIMONIALS_SUBMITTED = [
  {
    id: "T-01",
    bookingId: "SE-7431K",
    rating: 5,
    title: "The quiet I didn't know I needed",
    content:
      "StayEasy has ruined most other booking sites for me. Every stay we've booked has felt considered.",
    status: "published",
    submittedAt: "Aug 12, 2025",
  },
];

export const REVIEWS_SUBMITTED = [
  {
    id: "R-01",
    bookingId: "SE-7431K",
    property: p("palm-bungalow"),
    rating: 5,
    title: "Wake up to the reef",
    content:
      "Wayan and team made check-in effortless. The plunge pool was perfect for the two of us.",
    status: "published",
    submittedAt: "Aug 12, 2025",
  },
];

export const findBooking = (id) => BOOKINGS.find((b) => b.id === id);
export const findConversation = (bookingId) =>
  CONVERSATIONS.find((c) => c.bookingId === bookingId);
